import { useMutation } from '@tanstack/react-query';
import { MutationOptionsType } from '@src/types';
import { BinderSignInViaGoogleCommand, TeambinderApiService } from '@src/api';
import { ApiResponse } from '@src/api/custom/models/ApiResponse';

interface Props {
  options?: MutationOptionsType<ApiResponse, BinderSignInViaGoogleCommand>;
}

const fetchGoogleLogin = async (
  tokenRequest: BinderSignInViaGoogleCommand,
) => {
  const response = await TeambinderApiService.signInViaGoogle({
    requestBody: tokenRequest,
  });
  return response;
};

export const useMutationGoogleLogin = ({ options }: Props) => {
  return useMutation(fetchGoogleLogin, {
    onSuccess: (data: any) => {
      console.log('onSuccess');
    },
    onError: (error: any) => {
      console.log('onError');
    },
    onSettled: () => {
      console.log('onSettled');
    },
    ...options,
  });
};
